/**
 * Validates and normalizes string values, treating empty strings as undefined.
 * Useful for handling optional string props with fallback logic.
 *
 * @param value - The string value to check
 * @returns The trimmed string if non-empty, otherwise undefined
 */
export const asNonEmpty = (
  value: string | null | undefined
): string | undefined => {
  const normalized = value?.trim();
  return normalized && normalized.length > 0 ? normalized : undefined;
};
